import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function CircleArrowFowardIcon(props) {
    const { style, color, onClick } = props;
    const classes = useStyles({color, ...props})()
    return(
        <svg onClick={onClick}  className={classes.container}  style={style} width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.5 0C16.2897 0 21 4.7103 21 10.5C21 16.2897 16.2897 21 10.5 21C4.7103 21 0 16.2897 0 10.5C0 4.7103 4.7103 0 10.5 0ZM10.5 1.575C5.57865 1.575 1.575 5.57865 1.575 10.5C1.575 15.4213 5.57865 19.425 10.5 19.425C15.4213 19.425 19.425 15.4213 19.425 10.5C19.425 5.57865 15.4213 1.575 10.5 1.575ZM9.54198 6.29759L13.2023 9.94213C13.3503 10.0902 13.4333 10.2907 13.4333 10.4997C13.4333 10.7097 13.3503 10.9102 13.2023 11.0583L9.54198 14.7018C9.38868 14.8551 9.18708 14.9317 8.98653 14.9317C8.78493 14.9317 8.58228 14.8551 8.42898 14.6997C8.12238 14.391 8.12343 13.8933 8.43108 13.5867L11.5307 10.4997L8.43108 7.41373C8.12343 7.10713 8.12238 6.60838 8.42898 6.29969C8.73558 5.98993 9.23328 5.99203 9.54198 6.29759Z" />
        </svg>
    )
}

const useStyles = ({color, ...props}) => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: color ? color : theme.palette.primary.main,
            width: props.width,
         },
    }
}));